export const config = {
    // APIURL : '47.100.75.167',
    APIURL : 'http://api.xinyunyiyun.cn/',
    URL : 'http://h5.xinyunyiyun.cn/',
    OVERTIME: 30 * 24 * 60 * 60 * 1000,
    CLASS: ['初一', '初二', '初三']
}

